import { Stack, Typography, useTheme } from "@mui/material";
import { BellIcon } from "components";
import React from "react";

export const ConfigItemsLayout = ({
  title,
  description,
  children,
  icon,
}: {
  title: string;
  description: string;
  children: React.ReactNode;
  icon: React.ReactNode;
}) => {
  const theme = useTheme();
  return (
    <Stack direction={"row"}>
      <Stack
        flex={1}
        direction={"column"}
        gap={"8px"}
        alignItems={"top"}
        height={"fit-content"}
      >
        <Stack direction={"row"} gap={"4px"} flex={1} alignItems={"center"}>
          {icon}
          <Typography variant="h6">{title}</Typography>
        </Stack>
        <Typography variant="body-small" color={theme.palette.lightBg.low}>
          {description}
        </Typography>
      </Stack>
      {children}
    </Stack>
  );
};
